export default __webpack_public_path__ + "static/media/temp_2.59d316da.png";